module.exports = __webpack_public_path__ + "f25a95aed56f1481ecfc02fa997415e1.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/desktop_top_keyart_h1920.png
// module id = 241
// module chunks = 0